var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-account-form"},[_c('section',{staticClass:"mb-5"},[_c('UserProfileAccount')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }